<!-- NUEVO ESTILO -->
<div class="min-h-screen p-4">
  <div class="w-full max-w-6xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden">
    <!--div class="header">
      <app-credit-modal [show]="modalAbierto" (close)="modalAbierto = false"></app-credit-modal>

      <button class="bg-[#171d35] text-white px-4 py-2 rounded m-4" (click)="modalAbierto = true">
        Simular Crédito nuevo pr
      </button>
    </div-->
    <app-profile-public-cover [userId]="userId" [isSimulaCredito]="true"></app-profile-public-cover>

    <div class="px-6 pb-6">
      <!-- FORMULARIO -->
      <hr />
      <!-- BARRA -->
      <div class="w-full bg-gray-200 rounded-full h-2.5 my-4">
        <div class="bg-blue-600 h-2.5 rounded-full transition-all duration-500 ease-in-out"
          [style.width]="((currentTabIndex + 1) * 100) / 6 + '%'"></div>
      </div>

      <!-- DATOS DEL PERFIL -->
      <!-- NOMBRE -->
      <!-- 
      <div class="mb-2">
        <div class="flex items-center gap-2">
          <h1 class="text-2xl font-semibold text-gray-900">
            {{ user['name'] }}
          </h1>
          <button
            class="text-blue-600 text-sm border border-blue-600 px-3 py-1 rounded-full hover:bg-blue-50 transition"
          >
            <i class="text-[20px] bx bx-badge-check"></i> Usuario Verificado
          </button>
        </div>
      </div>
 -->
      <!-- CORREO -->
      <!-- 
      <div class="flex items-center gap-1 text-sm text-gray-600 mb-2">
        <span
          ><strong>Correo: </strong>
          <a
            href="{{ user['email'] }}"
            class="text-blue-600 hover:underline"
            >{{ user['email'] }}</a
          ></span
        >
      </div>
 -->
      <!-- TELEFONO -->
      <!-- 
      <p class="text-gray-700 mb-1">
        <strong>Telefono:</strong> {{ user["phone"] || "- Pendiente -" }}
      </p>
 -->
      <!-- ESTADO -->
      <!-- 
      <p class="text-gray-700 mb-1">
        <strong>Estado:</strong>
        <button
          class="text-blue-600 text-sm border border-blue-600 px-3 py-1 rounded-full hover:bg-blue-50 transition"
        >
          <strong>{{
            user["status"] == 0 ? "Activo" : "Inactivo"
          }}</strong>
          <i class="bx bx-badge-check"></i>
        </button>
      </p>
 -->
      <!-- FORMULARIO -->
      <!-- <hr /> -->

      <!-- BARRA -->
      <!-- 
      <div class="w-full bg-gray-200 rounded-full h-2.5 my-4">
        <div
          class="bg-blue-600 h-2.5 rounded-full transition-all duration-500 ease-in-out"
          [style.width]="((currentTabIndex + 1) * 100) / 6 + '%'"
        ></div>
      </div>
 -->
      <div class="w-full max-w-6xl mx-auto bg-white">
        <!-- Tab Navigation -->
        <div class="border-b border-gray-200">
          <nav class="flex space-x-8" aria-label="Tabs">
            <button *ngFor="let tab of tabs; trackBy: trackByTab" (click)="setActiveTab(tab.id, tab)"
              [class]="getTabClasses(tab.active)"
              class="group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200 needs-validation createContact-form fade-in">
              {{ tab.icon }}
              {{ tab.title }}
            </button>
          </nav>
        </div>

        <!-- Tab Content -->
        <form [formGroup]="requestForm" class="py-6" (ngSubmit)="createRequest()">
          <!-- Datos Personales Tab -->
          <div *ngIf="activeTab === 'personal'" class="space-y-6 needs-validation createContact-form fade-in">
            <!-- Campos antes de genero -->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
              <!-- Nombres -->
              <div>
                <label for="name" class="block text-sm font-medium text-gray-700 mb-2">
                  Nombres
                </label>
                <input type="text" placeholder="Ingrese nombres"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  formControlName="name" required />
                <div *ngIf="validacionInputReq('name')" style="display: block" class="invalid-feedback">
                  Por favor ingrese los nombres.
                </div>
              </div>

              <!-- Apellidos -->
              <div>
                <label for="lastName" class="block text-sm font-medium text-gray-700 mb-2">
                  Apellidos
                </label>
                <input type="text" placeholder="Ingrese apellidos"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  formControlName="lastName" required />
                <div *ngIf="validacionInputReq('lastName')" style="display: block" class="invalid-feedback">
                  Por favor ingrese los apellidos.
                </div>
              </div>

              <!-- Tipo de documento -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Tipo de documento
                </label>
                <select formControlName="documentType"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  required>
                  <option value="" selected disabled>Seleccione</option>
                  <option value="CC">Cédula de ciudadanía</option>
                  <option value="CE">Cédula de extranjeria</option>
                  <option value="NIT">NIT</option>
                </select>
                <div *ngIf="validacionInputReq('documentType')" style="display: block" class="invalid-feedback">
                  Porfavor ingrese un tipo de documento.
                </div>
              </div>

              <!-- Número documento -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Número documento
                </label>
                <input formControlName="documentNumber" required type="text" placeholder="Ingrese documento"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500" />
                <div *ngIf="validacionInputReq('documentNumber')" style="display: block" class="invalid-feedback">
                  Porfavor ingrese un tipo de documento.
                </div>
              </div>

              <!-- Fecha de nacimiento -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Fecha de nacimiento
                </label>
                <input type="date" placeholder="dd/mm/aaaa"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  formControlName="birthDate" required />
                <div *ngIf="validacionInputReq('birthDate')" style="display: block" class="invalid-feedback">
                  Por favor ingrese la fecha.
                </div>
              </div>

              <!-- País -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  País
                </label>
                <select formControlName="country"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  required>
                  <option *ngFor="let p of paises" [value]="p.codigo">
                    {{ p.nombre }}
                  </option>
                </select>
                <div *ngIf="validacionInputReq('country')" style="display: block" class="invalid-feedback">
                  Por favor seleccione un país.
                </div>
              </div>

              <!-- Departamento -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Departamento
                </label>
                <select formControlName="department" (change)="onDepartmentChange($event)"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  required>
                  <option value="" selected disabled>Seleccione</option>
                  <option *ngFor="let d of departamentos" [value]="d.codigo">
                    {{ d.nombre }}
                  </option>
                </select>
                <div *ngIf="validacionInputReq('department')" style="display: block" class="invalid-feedback">
                  Por favor seleccione un departamento.
                </div>
              </div>

              <!-- Ciudad de residencia -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Ciudad de residencia
                </label>
                <select formControlName="city"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  required>
                  <option value="" selected disabled>Seleccione</option>
                  <option *ngFor="let m of municipios" [value]="m.codigo_municipio">
                    {{ m.nombre_municipio }}
                  </option>
                </select>
                <div *ngIf="validacionInputReq('city')" style="display: block" class="invalid-feedback">
                  Por favor seleccione una ciudad.
                </div>
              </div>

              <!-- Dirección -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Dirección
                </label>
                <input type="text" placeholder="Ingrese dirección"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  formControlName="address" required />
                <div *ngIf="validacionInputReq('address')" style="display: block" class="invalid-feedback">
                  Porfavor ingrese una dirección valida.
                </div>
              </div>

              <!-- Número de celular -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Número de celular
                </label>
                <input type="tel" placeholder="Ingrese celular"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  formControlName="cellPhone" required />
                <div *ngIf="validacionInputReq('cellPhone')" style="display: block" class="invalid-feedback">
                  Porfavor ingrese un número de celular valido.
                </div>
              </div>

              <!-- Correo electrónico -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Correo electrónico
                </label>
                <input type="email" placeholder="Ingrese email"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  formControlName="email" required />
                <div *ngIf="validacionInputReq('email')" style="display: block" class="invalid-feedback">
                  Ingrese una email valido.
                </div>
              </div>

              <!-- Género -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Género
                </label>
                <select
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  formControlName="gender" required>
                  <option value="" selected disabled>Seleccione</option>
                  <option value="Male">Masculino</option>
                  <option value="Female">Femenino</option>
                </select>
                <div *ngIf="validacionInputReq('gender')" style="display: block" class="invalid-feedback">
                  Porfavor ingrese genero.
                </div>
              </div>
            </div>
          </div>

          <!-- Información Laboral Tab -->
          <div *ngIf="activeTab === 'laboral'" class="space-y-6 needs-validation createContact-form fade-in">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
              <div class="mb-3">
                <label for="employeeType-input" class="form-label">Tipo de empleado</label>
                <div class="col-md-12">
                  <select class="form-select" placeholder="Seleccione un tipo de empleado"
                    formControlName="employeeType" required>
                    <option value="" selected disabled>Seleccione</option>
                    <option value="0">Empleado</option>
                    <option value="1">Independiente</option>
                    <option value="2">Pensionado</option>
                  </select>
                  <div *ngIf="validacionInputReq('employeeType')" style="display: block" class="invalid-feedback">
                    Porfavor ingrese tipo de empleado.
                  </div>
                </div>
              </div>

              <div class="mb-3" *ngIf="requestForm.controls['employeeType'].value === '0'">
                <label for="enterpriseName-input" class="form-label">Nombre empresa</label>
                <div class="col-md-12">
                  <input type="text" id="enterpriseName-input" class="form-control" placeholder="Ingrese nombre empresa"
                    formControlName="enterpriseName" required />
                  <div *ngIf="validacionInputReq('enterpriseName')" style="display: block" class="invalid-feedback">
                    Por favor ingrese el nombre de la empresa.
                  </div>
                </div>
              </div>

              <div class="mb-3" *ngIf="requestForm.controls['employeeType'].value === '0'">
                <label for="contractType-input" class="form-label">Tipo de contrato</label>
                <div class="col-md-12">
                  <select class="form-select" placeholder="Seleccione un tipo de contrato"
                    formControlName="contractType" required>
                    <option value="" selected disabled>Seleccione</option>
                    <option value="0">Termino fijo</option>
                    <option value="1">Indefinido</option>
                    <option value="2">Prestación de servicios</option>
                  </select>
                  <div *ngIf="validacionInputReq('contractType')" style="display: block" class="invalid-feedback">
                    Por favor ingrese el tipo de contrato.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Información Financiera Tab -->
          <div *ngIf="activeTab === 'financiera'" class="space-y-6 needs-validation createContact-form fade-in">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
              <div class="mb-3">
                <label for="incoming-input" class="form-label">Ingreso fijo</label>
                <input (input)="onDocumentNumberInputFrom($event, 'incoming')" type="text" id="incoming-input"
                  class="form-control" placeholder="Ingrese ingreso fijo" formControlName="incoming" required />
                <div *ngIf="validacionInputReq('incoming')" style="display: block" class="invalid-feedback">
                  Por favor ingrese ingresos fijos.
                </div>
              </div>
              <div class="mb-3">
                <label for="anotherIncoming-input" class="form-label">Otros ingresos</label>
                <input (input)="onDocumentNumberInputFrom($event, 'anotherIncoming')" type="text"
                  id="anotherIncoming-input" class="form-control" placeholder="Otros ingresos"
                  formControlName="anotherIncoming" required />
                <div *ngIf="validacionInputReq('anotherIncoming')" style="display: block" class="invalid-feedback">
                  Por favor ingrese un otros ingresos.
                </div>
              </div>
              <div class="mb-3">
                <label for="totalIncoming-input" class="form-label">Total ingresos</label>
                <input id="totalIncoming-input" type="text" class="form-control" formControlName="totalIncoming" />
              </div>
              <div class="mb-3">
                <label for="personalExpenses-input" class="form-label">Gastos personales</label>
                <input (input)="
                    onDocumentNumberInputFrom($event, 'personalExpenses')
                  " type="text" id="personalExpenses-input" class="form-control"
                  placeholder="Ingrese Gastos personales" formControlName="personalExpenses" required />
                <div *ngIf="validacionInputReq('personalExpenses')" style="display: block" class="invalid-feedback">
                  Por favor ingrese gastos personales.
                </div>
              </div>
              <div class="mb-3">
                <label for="creditExpenses-input" class="form-label">Gastos por creditos</label>
                <input (input)="onDocumentNumberInputFrom($event, 'creditExpenses')" type="text"
                  id="creditExpenses-input" class="form-control" placeholder="Ingrese Gastos por creditos"
                  formControlName="creditExpenses" required />
                <div *ngIf="validacionInputReq('creditExpenses')" style="display: block" class="invalid-feedback">
                  Por favor ingrese Gastos por creditos.
                </div>
              </div>
              <div class="mb-3">
                <label for="totalAssets-input" class="form-label">Total Activos</label>
                <input (input)="onDocumentNumberInputFrom($event, 'totalAssets')" type="text" id="totalAssets-input"
                  class="form-control" placeholder="Total Activos" formControlName="totalAssets" required />
                <div *ngIf="validacionInputReq('totalAssets')" style="display: block" class="invalid-feedback">
                  Por favor ingrese un Total Activos.
                </div>
              </div>
              <div class="mb-3">
                <label for="totalLiabilities-input" class="form-label">Total Pasivos</label>
                <input (input)="
                    onDocumentNumberInputFrom($event, 'totalLiabilities')
                  " type="text" id="totalLiabilities-input" class="form-control" placeholder="Total Pasivos"
                  formControlName="totalLiabilities" required />
                <div *ngIf="validacionInputReq('totalLiabilities')" style="display: block" class="invalid-feedback">
                  Por favor ingrese un Total Pasivos.
                </div>
              </div>
            </div>
          </div>

          <!-- Información de Crédito Tab -->
          <div *ngIf="activeTab === 'credito'" class="space-y-6 needs-validation createContact-form fade-in">
            <div class="row">
              <div class="mb-1">
                <label for="tipoCredito-input" class="form-label">Tipo de credito</label>
                <div class="col-md-12">
                  <select class="form-select" placeholder="Seleccione un tipo de credito" formControlName="tipoCredito"
                    required>
                    <option value="" selected disabled>Seleccione</option>
                    <option *ngIf="this.isUser" value="Compra en tienda">
                      Compra en tienda
                    </option>
                    <option value="Libre inversion">Libre inversion</option>
                  </select>
                </div>
                <div *ngIf="validacionInputReq('tipoCredito')" style="display: block" class="invalid-feedback">
                  Seleccione un tipo de credito.
                </div>
              </div>

              <div class="mb-3">
                <label for="amount-input" class="form-label">Monto credito</label>
                <input (input)="onDocumentNumberInputFrom($event, 'amount')" type="text" id="amount-input"
                  class="form-control" placeholder="Ingrese el monto" formControlName="amount" required />
                <div *ngIf="validacionInputReq('amount')" style="display: block" class="invalid-feedback">
                  Porfavor ingrese el monto.
                </div>
              </div>
              <div class="mb-3">
                <label for="requestedTerm-input" class="form-label">Plazo (Meses)</label>
                <input type="number" min="1" max="24" id="requestedTerm-input" class="form-control"
                  placeholder="Ingrese el plazo" formControlName="requestedTerm" required />
                <div *ngIf="validacionInputReq('requestedTerm')" style="display: block" class="invalid-feedback">
                  Porfavor ingrese el plazo. (Max 24 meses)
                </div>
              </div>
            </div>
          </div>

          <!-- Información Bancaria Tab -->
          <div *ngIf="activeTab === 'bancaria'" class="space-y-6 needs-validation createContact-form fade-in">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
              <div class="mb-3">
                <label for="bank-input" class="form-label">Banco</label>
                <select class="form-select" placeholder="Seleccione una opcion" formControlName="bank" required>
                  <option value="" selected disabled>Seleccione</option>
                  <option *ngFor="let bank of listBanks" [value]="bank.id">
                    {{ bank.name }}
                  </option>
                </select>
                <div *ngIf="validacionInputReq('bank')" style="display: block" class="invalid-feedback">
                  Por favor seleccione un Banco.
                </div>
              </div>
              <div class="mb-3 row">
                <label for="accountType-input" class="form-label">Tipo de cuenta</label>
                <div class="col-md-12">
                  <select class="form-select" formControlName="accountType" required>
                    <option value="" selected disabled>Seleccione</option>
                    <option value="CH">Ahorros</option>
                    <option value="CC">Corriente</option>
                  </select>
                </div>
                <div *ngIf="validacionInputReq('accountType')" style="display: block" class="invalid-feedback">
                  Porfavor ingrese un tipo de cuenta.
                </div>
              </div>

              <div class="mb-3">
                <label for="accountNumber-input" class="form-label">Numero de cuenta</label>
                <input type="text" id="accountNumber-input" class="form-control"
                  placeholder="Ingrese el número de cuenta" formControlName="accountNumber" required />
                <div *ngIf="validacionInputReq('accountNumber')" style="display: block" class="invalid-feedback">
                  Porfavor ingrese el número de cuenta.
                </div>
              </div>
            </div>

            <div class="mb-3">
              <label for="accNumber-input" class="form-label">Documento titular de la cuenta</label>
              <input (ngModelChange)="validacionDocumento()" type="text" id="accNumber-input" class="form-control"
                placeholder="Ingrese el documento" formControlName="accNumber" required />
              <div *ngIf="validacionInputReq('accNumber')" style="display: block" class="invalid-feedback">
                Por favor ingrese el Documento titular de la cuenta.
              </div>

              <div *ngIf="validateDocument" style="display: block" class="invalid-feedback">
                Los documentos no coinciden.
              </div>
            </div>
          </div>

          <!-- Navigation Buttons -->
          <div
            class="flex justify-between items-center pt-6 border-t border-gray-200 needs-validation createContact-form fade-in">
            <button type="button" (click)="previousTab()" [disabled]="isFirstTab()"
              class="px-6 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200">
              Anterior
            </button>

            <button type="button" (click)="
                nextTab(
                  this.tabs[this.currentTabIndex + 1].id,
                  this.tabs[this.currentTabIndex + 1]
                )
              " [disabled]="isLastTab()"
              class="px-6 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200">
              Siguiente
            </button>

            <div class="" *ngIf="requestForm.valid">
              <button type="submit" [disabled]="!requestForm.valid"
                class="px-6 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200">
                Enviar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- FIN NUEVO ESTILO -->
</div>